export default function Marquee({ items }) {
  return (
    <div className="overflow-hidden border-y border-white/10 py-5 md:py-7 bg-ink">
      <div className="flex w-max whitespace-nowrap animate-marquee">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center" aria-hidden={half === 1}>
            {items.map((item, i) => (
              <span key={i} className="flex items-center">
                <span className="font-display text-outline uppercase text-6xl md:text-8xl leading-none px-6 md:px-10">
                  {item}
                </span>
                <span className="text-cyan text-3xl md:text-5xl">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
